'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useState } from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import CardProduct from 'components/cards/CardProduct';
import ButtonCTA from 'components/ui/ButtonCTA';
import ShowMore from 'components/ui/ShowMore';
import Text from 'components/ui/Text';

import ResultHeader from '../ResultHeader';
import skeletonStyles from '../Skeleton/Skeleton.module.scss';

import styles from './ProductResults.module.scss';

const itemsPerGroup = 8;

const ProductResults = ({ items, isLoading = false }) => {
    const products = items.filter(item => typeof item.id === 'string');
    const isNoResults = products.length === 0;

    const [visibleGroups, setVisibleGroups] = useState(1);

    const visibleItems = visibleGroups * itemsPerGroup;
    const allItemsVisible = visibleGroups * itemsPerGroup >= products.length;

    const remainingItems = Math.max(0, products.length - visibleItems);

    const handleMoreClick = () => {
        if (visibleItems < products.length) {
            setVisibleGroups(visibleGroups + 1);
        }
    };

    return (
        <section className={styles.root}>
            <ResultHeader
                type="Products"
                number={products.length}
                isLoading={isLoading}
                countLabel="saved"
            />
            {isLoading ? (
                <ul className={skeletonStyles.list}>
                    {new Array(4).fill(null).map((_, index) => (
                        <li className={skeletonStyles.listItem} key={index}>
                            <div className={skeletonStyles.skeletonCard}>
                                <div
                                    className={skeletonStyles.skeletonCardImage}
                                />
                                <div
                                    className={skeletonStyles.skeletonCardText}
                                >
                                    <span
                                        className={
                                            skeletonStyles.skeletonCardEyebrow
                                        }
                                    >
                                        <span
                                            className={skeletonStyles.textFill}
                                        >
                                            placeholder
                                        </span>
                                    </span>
                                    <span
                                        className={
                                            skeletonStyles.skeletonCardHeadline
                                        }
                                    >
                                        <span
                                            className={skeletonStyles.textFill}
                                        >
                                            Loading product name
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            ) : isNoResults ? (
                <ul className={styles.productList}>
                    <li className={styles.listItem}>
                        <div className={styles.zeroState}>
                            <div className={styles.zeroStateInner}>
                                <Text
                                    baseTheme="headingXSmall"
                                    themes={{ medium: 'headingSmall' }}
                                    className={styles.zeroStateText}
                                    as="p"
                                >
                                    Add products to plan recipes and meals
                                    around—or just so you can remember your
                                    faves.
                                </Text>
                                <ButtonCTA
                                    link={{ slug: 'products' }}
                                    style="filled-blue-ocean"
                                    className={styles.cta}
                                    text="Explore Products"
                                />
                            </div>
                        </div>
                    </li>
                </ul>
            ) : (
                <>
                    <ul
                        className={styles.productList}
                        data-show-count={visibleItems}
                    >
                        {products.map((product, index) => {
                            return (
                                <li
                                    className={cx(styles.listItem, {
                                        [styles.show]: index < visibleItems,
                                    })}
                                    key={
                                        product?.id || product?.sys?.id || index
                                    }
                                >
                                    <CardProduct
                                        color={product.color}
                                        category={product.category}
                                        eyebrow={product.eyebrow}
                                        image={product.image}
                                        imageLarge={product.image}
                                        displayName={product.displayName}
                                        slug={product.slug}
                                        theme={product.theme}
                                        icon={product.icon}
                                        id={product?.id || product?.sys?.id}
                                    />
                                </li>
                            );
                        })}
                        <li
                            key="end-card"
                            className={cx(styles.listItem, {
                                [styles['listItem--no-results']]: isNoResults,
                            })}
                        >
                            <div
                                className={
                                    styles['listItem--no-results-filler']
                                }
                            ></div>
                        </li>
                    </ul>
                    {!allItemsVisible && (
                        <ShowMore
                            onClick={handleMoreClick}
                            remainingItems={remainingItems}
                        />
                    )}
                </>
            )}
        </section>
    );
};

ProductResults.propTypes = {
    items: PropTypes.array.isRequired,
    isLoading: PropTypes.bool,
};

export default ProductResults;
